(function() {
  const path = window.location.pathname;

  
  const overrides = [
    {
      match: '/policies/legal-notice',                
      newTitle: 'Mentions Légales'
    },
    {
      match: '/policies/privacy-policy',
      newTitle: 'Politique De Confidentialité'
    },
    {
      match: '/policies/refund-policy',
      newTitle: 'Politique De Retours & De Remboursements'
    },
    {
      match: '/policies/terms-of-service',
      newTitle: 'Conditions générales d’utilisation et de vente'
    }
  ];

  
  const override = overrides.find(o => path.includes(o.match));
  if (!override) return;

  const newTitle = override.newTitle;

  
  document.title = newTitle;

  
  document.documentElement.style.visibility = 'hidden';

 
  const observer = new MutationObserver((mutations, obs) => {
    const h1 = document.querySelector('h1');
    if (h1) {
      h1.textContent = newTitle;
      document.documentElement.style.visibility = 'visible';
      obs.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
